import { Range, getTrackBackground } from 'react-range'
import { formatDistance } from 'utils/formatDistance'
import cn from 'classnames'
import s from '../RangeSlider.module.scss'

interface Props {
  min: number
  max: number
  value: number
  onChange?: (value: number) => void
  className?: string
  style?: React.CSSProperties
}

const defaultProps: Partial<Props> = {
  onChange: () => null,
  className: undefined,
  style: {},
}

const RangeSlider = ({
  min,
  max,
  value,
  onChange,
  className,
  ...otherProps
}: Props): JSX.Element => {
  const handleOnChange = ([newValue]: number[]) => {
    if (onChange) onChange(newValue)
  }
  return (
    <div
      className={cn('rangeSlider', s.rangeSlider, className)}
      {...otherProps}
    >
      <div className={s.labelWrapper}>
        <span className={s.label}>{formatDistance(min)}</span>
        <span className={s.label}>{formatDistance(max)}</span>
      </div>
      <Range
        values={[value]}
        min={min}
        max={max}
        onChange={handleOnChange}
        renderTrack={({
          props: { onMouseDown, onTouchStart, ref },
          children,
        }) => (
          <div
            onMouseDown={onMouseDown}
            onTouchStart={onTouchStart}
            className={s.trackWrapper}
            role="button"
            tabIndex={0}
          >
            <div
              ref={ref}
              className={s.track}
              style={{
                background: getTrackBackground({
                  colors: [s.primary, s.grey],
                  values: [value],
                  min,
                  max,
                }),
              }}
            >
              {children}
            </div>
          </div>
        )}
        renderThumb={({ props, isDragged }) => (
          <div className={cn(s.thumb, { [s.dragged]: isDragged })} {...props}>
            <div className={s.thumbLabel}>{formatDistance(value)}</div>
          </div>
        )}
      />
    </div>
  )
}

RangeSlider.defaultProps = defaultProps
export default RangeSlider
